const setOrganizationData = (
  state,
  {
    breakCategories,
    breakTypes,
    businessProcesses,
    orgId,
    orgName,
    orgKafkaTopicName,
    reportingServerUrl,
    configurationVersion,
    dispositionCodeCategorySets,
    enableIncomingCallRemoteAcceptOnPrimaryDevice,
    interactionDetailsDisplayTemplates,
    interactionVariables,
    skills,
    customerAIAssistanceBotURL,
    loadAllowances
  }
) => {
  Object.assign(state.breakCategories, breakCategories || []);
  Object.assign(
    state.breakTypes,
    breakTypes.sort(function(a, b) {
      const nameA = a.name.toUpperCase();
      const nameB = b.name.toUpperCase();
      return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
    }) || []
  );
  Object.assign(state.businessProcesses, businessProcesses || []);
  Object.assign(state.dispositionCodeCategorySets, dispositionCodeCategorySets || []);

  state.orgId = orgId;
  state.orgName = orgName;
  state.orgKafkaTopicName = orgKafkaTopicName;
  state.orgReportingServerUrl = reportingServerUrl;
  state.configurationVersion = configurationVersion;
  state.dispositionCodeCategorySets = dispositionCodeCategorySets;
  state.enableIncomingCallRemoteAcceptOnPrimaryDevice = enableIncomingCallRemoteAcceptOnPrimaryDevice;
  state.interactionDetailsDisplayTemplates = interactionDetailsDisplayTemplates;
  state.interactionVariables = interactionVariables;
  state.skills = skills;
  state.customerAIAssistanceBotURL = customerAIAssistanceBotURL;
  state.loadAllowances = loadAllowances;
};

const setOrganizationShortName = (state, organizationShortName) => {
  state.orgShortName = organizationShortName;
};

export default {
  setOrganizationData,
  setOrganizationShortName
};
